import type {
  TrainingData,
  SaveTrainingDataPayload,
  EmailTemplate,
  CreateEmailTemplatePayload,
  PastResponse,
  SavePastResponsePayload,
} from '@drahft/api-client';

import { API_ROUTES } from '@config/routes';
import api from './api';

// ─── Training Data ──────────────────────────────────────────────────────────

export const getTrainingData = () =>
  api.get<TrainingData | Record<string, never>>(API_ROUTES.TRAINING_DATA.BASE);

export const saveTrainingData = (payload: SaveTrainingDataPayload) =>
  api.put<{ id: string }>(API_ROUTES.TRAINING_DATA.BASE, payload);

export const updateTrainingSection = (key: string, content: string) =>
  api.patch<{ id: string }>(API_ROUTES.TRAINING_DATA.SECTION(key), { content });

export const deleteTrainingData = () =>
  api.delete<{ deleted: boolean }>(API_ROUTES.TRAINING_DATA.BASE);

// ─── Email Templates ────────────────────────────────────────────────────────

export const getEmailTemplates = () => api.get<EmailTemplate[]>(API_ROUTES.TRAINING_DATA.TEMPLATES);

export const createEmailTemplate = (template: CreateEmailTemplatePayload) =>
  api.post<EmailTemplate>(API_ROUTES.TRAINING_DATA.TEMPLATES, template);

export const updateEmailTemplate = (id: string, updates: Partial<CreateEmailTemplatePayload>) =>
  api.put<EmailTemplate>(API_ROUTES.TRAINING_DATA.TEMPLATE_BY_ID(id), updates);

export const deleteEmailTemplate = (id: string) =>
  api.delete<{ deleted: boolean }>(API_ROUTES.TRAINING_DATA.TEMPLATE_BY_ID(id));

// ─── Past Responses ─────────────────────────────────────────────────────────

export const getPastResponses = (limit = 50) =>
  api.get<PastResponse[]>(`${API_ROUTES.TRAINING_DATA.RESPONSES}?limit=${limit}`);

export const savePastResponse = (response: SavePastResponsePayload) =>
  api.post<PastResponse>(API_ROUTES.TRAINING_DATA.RESPONSES, response);

export const deletePastResponse = (id: string) =>
  api.delete<{ deleted: boolean }>(API_ROUTES.TRAINING_DATA.RESPONSE_BY_ID(id));

export default {
  getTrainingData,
  saveTrainingData,
  updateTrainingSection,
  deleteTrainingData,
  getEmailTemplates,
  createEmailTemplate,
  updateEmailTemplate,
  deleteEmailTemplate,
  getPastResponses,
  savePastResponse,
  deletePastResponse,
};
